import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IVotePopoverItem } from '../../models/vote-popover-item';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';

@Component({
    selector: 'app-view-votes-popover',
    templateUrl: './view-votes-popover.component.html',
    styleUrl: './view-votes-popover.component.scss',
    standalone: false
})
export class ViewVotesPopoverComponent {
  @ViewChild('viewVotePopover') viewVotePopover!: NgbPopover;
  @Input() id: string = 'view-vote-popover'
  @Input() votePopoverItems: IVotePopoverItem[] = [];
  @Input() popoverTitle: string = '';

  closeSymbol: string = materialSymbols.close;


  public openPopover() : void {
    this.viewVotePopover.open();
  }
}
